<template>
  <header
    class="header absolute top-0 right-0 flex items-center justify-between"
  >
    <div class="flex-a">
      <ul v-if="!mobile" class="flex">
        <li v-for="(item, i) in ctas" :key="`${item.href}-${i}`">
          <Button
            type="external"
            :text="item.call_to_action"
            textsize="lg"
            :path="item.href"
            icon="LinkIcon"
            :iconright="true"
            iconsize="1rem"
            class="btn-sm btn-secondary mr-2"
          />
        </li>
      </ul>
      <Navigation />
    </div>
  </header>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Navigation from '@/components/Navigation.vue'
import Button from '@/components/buttons/Button.vue'

export default {
  name: 'Header',

  components: {
    Button,
    Navigation
  },

  computed: {
    ...mapState(['touch', 'mobile', 'isIframe']),
    ...mapGetters(['options']),

    ctas() {
      return this.options.calls_to_action.filter(
        item => item.href && item.call_to_action
      )
    }
  }
}
</script>
